const form = {
  formId: "tax-personal-05",
  formField: {
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[01] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Tên người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId1: {
      name: "taxId1",
      label: "[05] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    organizationName: {
      name: "organizationName",
      label: "[12] Tên tổ chức khai thay (nếu có)",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên tổ chức",
    },
    taxId2: {
      name: "taxId2",
      label: "[13] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    district: {
      name: "district",
      label: "[15] Quận/huyện",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    province: {
      name: "province",
      label: "[16] Tỉnh/thành phố",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    address: {
      name: "address",
      label: "[14] Địa chỉ",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[20] Tên đại lý thuế (nếu có)",
      type: "text",
      placeholder: "",
    },
    taxAgencyId: {
      name: "taxAgencyId",
      label: "[21] Mã số thuế đại lý",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    checkbox1: {
      name: "checkbox1",
      label: "Tổ chức khai thay",
      type: "text",
    },
    phone: {
      name: "phone",
      label: "[17] Điện thoại",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số điện thoại",
      invalidMsg: "Số điện thoại không hợp lệ",
    },
    fax: {
      name: "fax",
      label: "[18] Fax",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập fax",
    },
    email: {
      name: "email",
      label: "[19] Email",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập email",
      invalidMsg: "Email không hợp lệ",
    },

    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập họ và tên",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
